import { Controller } from "@hotwired/stimulus"

// Replica GoogleMapContainer.tsx del frontend.
// Carga Google Maps JS API dinámicamente y renderiza un mapa con marker.
// Frontend: GoogleMap center={lat,lng} zoom=15, sin controles, height 100px, border-radius 5px.
const API_KEY = "AIzaSyDH5JjS5uBbnTzZTEMGQQvdM4dUMANncNA"

export default class extends Controller {
  static values = { lat: Number, lng: Number }

  connect() {
    this.loadGoogleMaps().then(() => this.initMap())
  }

  loadGoogleMaps() {
    if (window.google?.maps) return Promise.resolve()

    return new Promise((resolve) => {
      if (document.querySelector(`script[src*="maps.googleapis.com"]`)) {
        const check = setInterval(() => {
          if (window.google?.maps) { clearInterval(check); resolve() }
        }, 50)
        return
      }
      const script = document.createElement("script")
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`
      script.async = true
      script.onload = () => resolve()
      document.head.appendChild(script)
    })
  }

  initMap() {
    const center = { lat: this.latValue, lng: this.lngValue }
    const map = new google.maps.Map(this.element, {
      center,
      zoom: 15,
      zoomControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
    })
    new google.maps.Marker({ position: center, map })
  }
}
